/**
 * Mobile Header Scroll Behavior
 * - Scrolling DOWN: hides logo/icons row, only search bar visible
 * - Scrolling UP: shows full header
 * - Only active on mobile (< 768px)
 */
(function() {
  'use strict';

  const SCROLL_THRESHOLD = 15;
  const MOBILE_BREAKPOINT = 768;
  const TOP_OFFSET = 50;

  class MobileHeaderScroll {
    constructor() {
      this.header = document.querySelector('store-header');
      if (!this.header) return;

      this.lastScrollY = window.scrollY;
      this.lastDirection = null;
      this.scrollDistance = 0;
      this.isHidden = false;
      this.ticking = false;

      this.init();
    }

    init() {
      this.header.classList.add('mobile-header-scroll-enabled');

      this.boundScrollHandler = this.onScroll.bind(this);
      this.boundResizeHandler = this.onResize.bind(this);

      this.toggleListeners();
      window.addEventListener('resize', this.boundResizeHandler);
    }

    toggleListeners() {
      if (window.innerWidth < MOBILE_BREAKPOINT) {
        window.addEventListener('scroll', this.boundScrollHandler, { passive: true });
      } else {
        window.removeEventListener('scroll', this.boundScrollHandler);
        this.showHeader();
      }
    }

    onResize() {
      this.toggleListeners();
    }

    onScroll() {
      if (!this.ticking) {
        requestAnimationFrame(() => {
          this.updateHeader();
          this.ticking = false;
        });
        this.ticking = true;
      }
    }

    updateHeader() {
      const currentScrollY = window.scrollY;
      const delta = currentScrollY - this.lastScrollY;
      const direction = delta > 0 ? 'down' : 'up';

      // At top of page - always show full header
      if (currentScrollY < TOP_OFFSET) {
        this.showHeader();
        this.scrollDistance = 0;
        this.lastDirection = null;
        this.lastScrollY = currentScrollY;
        return;
      }

      // Track scroll distance in current direction
      if (direction === this.lastDirection) {
        this.scrollDistance += Math.abs(delta);
      } else {
        // Direction changed - reset distance
        this.scrollDistance = Math.abs(delta);
        this.lastDirection = direction;
      }

      // Apply changes when threshold is reached
      if (this.scrollDistance > SCROLL_THRESHOLD) {
        if (direction === 'down' && !this.isHidden) {
          this.hideHeader();
        } else if (direction === 'up' && this.isHidden) {
          this.showHeader();
        }
      }

      this.lastScrollY = currentScrollY;
    }

    hideHeader() {
      this.header.classList.add('header--compact');
      this.isHidden = true;
    }

    showHeader() {
      this.header.classList.remove('header--compact');
      this.isHidden = false;
    }

    destroy() {
      window.removeEventListener('scroll', this.boundScrollHandler);
      window.removeEventListener('resize', this.boundResizeHandler);
      this.header.classList.remove('mobile-header-scroll-enabled', 'header--compact');
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new MobileHeaderScroll());
  } else {
    new MobileHeaderScroll();
  }
})();
